import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { AppContext } from "src/contexts/AppContext";
import * as Constants from "../../core/Constants/Constants";
import { findQuestionInService, resolveContactPerson } from "src/utils";

export default function AccountsPayableSummaryPanel(): JSX.Element {
  const { t } = useTranslation();
  const { globalState } = useContext(AppContext);

  const service = globalState.services.find(
    (item) => item.data.code === Constants.ServiceCode.AccountsPayable
  );

  const contactPersonQuestion = findQuestionInService(
    service,
    Constants.AccountPayableQuestion.Q0221
  );
  const contactPerson = resolveContactPerson(
    contactPersonQuestion?.data?.options?.find(
      (item) => item.key === contactPersonQuestion.data.userValue
    )?.value
  );
  const nrInvoices = findQuestionInService(
    service,
    Constants.AccountPayableQuestion.Q0201
  )?.data?.userValue;

  const invoicesText = nrInvoices
    ? `${t("PanelHeader.NrInvoicesText")} ${t("PanelHeader.NrInvoices", {
        nrInvoices,
      })}`
    : t("PanelHeader.NrInvoicesText");

  return (
    <article className="gt-summaryPanel">
      <div className="gt-summaryPanel__contactPerson">
        {t("PanelHeader.ContactPersonClientText", { contactPerson })}
      </div>
      <div className="gt-summaryPanel__data">{invoicesText}</div>
    </article>
  );
}
